export default {
  title: 'Arena の新機能',
  since: 'バージョン {{version}} 以降',
  experimental: '試験運用',
  dontShowAgain: '今後表示しない',
  slideCounter: '{{current}} / {{total}}',
  noItems: '表示する新機能はありません。',
  items: {
    dataMatrixExport: {
      title: `データをマトリクスとしてエクスポート`,
      description: `**データ > エクスプローラー**で複数エンティティ（例：各レコードの種）を選択し、**エクスポート**をクリックして**エクスポート形式：データマトリクス**を選ぶと、種（または他の属性）ごとに1行、レコードごとに1列で、選択した値（例：被度）がセルに入った表を取得できます。

これは **Turboveg**、**Juice**、**Synbiosys** などの植生解析ツールに必要な形式です。一部のレコードのみをエクスポートするには、エクスプローラーでフィルターを設定してください。`,
    },
    mobilePreview: {
      title: 'Arena Mobile で調査をプレビュー',
      description: `フォームデザイナーで **プレビュー** ボタンの横のメニューを開き、**プレビュー (モバイル)** を選ぶと、下書きの調査を **Arena Mobile** での表示どおりに、スマートフォンまたはタブレット、縦向きまたは横向きで試すことができます。

プレビューはブラウザで実行されるため、実機の一部の機能 (地図やカメラなど) は利用できません。`,
    },
    requiredIf: {
      title: '条件付き必須属性',
      description: `フォームデザイナーで属性の **検証ルール** タブを開き、**条件を満たす場合に必須** を選んで条件を入力します。条件が真の場合のみ、その属性は必須になります。

データ入力中は、条件を満たす場合のみ「値は必須です」エラーが表示されます。`,
    },
    themeSelector: {
      title: 'ライトテーマとダークテーマ',
      description: `ヘッダー（ログインページにもあります）の **テーマ** メニューで **ライト** と **ダーク** を切り替えるか、**システム設定** に従うことができます。`,
    },
    surveyCompare: {
      title: '調査の比較と更新',
      description: `**ダッシュボード**の**高度な機能 > 比較 / ファイルから更新**で、この調査を別のArenaサーバー（例：テストサーバー）からエクスポートした調査、またはこのサーバー上の別の調査と比較できます。

差分を確認し、選択した変更のみを適用します。変更は調査を公開するまで下書きとして保存されます。`,
    },
    usersBackup: {
      title: 'ユーザーのバックアップと復元',
      description: `**ユーザー**の**バックアップ / 復元**で、すべてのユーザーを調査での役割やユーザーグループとともにエクスポートし、別のArenaサーバーに復元できます。

復元の前に、ユーザーごとに処理を選択できます。`,
    },
    samplingPointDataWhisp: {
      title: '抽出地点のWhisp分析',
      description: `**抽出地点データ**カテゴリで**Whisp分析を生成**を使うと、すべての抽出地点の位置を**Open Foris Whisp**で分析できます。

分析はバックグラウンドで実行され、結果は新しいカテゴリに保存されます。`,
    },
    dashboardUpgrade: {
      title: '新しいダッシュボード',
      description: `**ダッシュボード**が新しくなりました：レコードと貢献者を一目で確認でき、収集データの地図や追加されたレコードの推移も表示されます。`,
    },
    clearNonApplicableValues: {
      title: '適用対象外の値の消去',
      description: `データ入力中、変更によって他の項目が適用対象外になると、確認の後にその値が消去されます。

調査管理者は**適用対象外の属性の値を保持する**（**調査情報 > セキュリティ**）で以前の動作を維持できます。`,
    },
    systemLogs: {
      title: 'システムログ',
      description: `**システム管理 > システムログ**で、テキストやレベルで絞り込みながらサーバーのログをリアルタイムで確認できます。`,
    },
    dataQueryAiGenerate: {
      title: 'AI でデータエクスプローラーのクエリを作成',
      description: `**データエクスプローラー**で、探しているデータを自然な言葉で説明すると（例：*「各州の樹種別の本数」*）、AI がクエリを作成します。

クエリを保存するときに、AI が名前と説明を提案することもできます。

*ユーザープロフィールで AI 機能を有効にする必要があります。*`,
    },
    recordPrint: {
      title: 'レコードの印刷',
      description: `レコードエディターの PDF ボタンから、レコードを印刷用の **Word** または **PDF** ドキュメント（画像を含む）としてエクスポートできます。

ページの向き（縦・横）を選択できます。`,
    },
    attributeClone: {
      title: 'フォームデザイナーでの属性の複製',
      description: `**フォームデザイナー**で属性のメニューを使い、同じエンティティまたは別のエンティティに**複製**できます。すべてのプロパティがコピーされます。`,
    },
    odkImport: {
      title: 'ODK からの調査とデータのインポート',
      description: `**ODK フォーム（.xml）**から新しい調査を作成し、**ODK Collect** で収集したデータをインポートできます。

*この機能はベータ版です。*`,
    },
    dynamicEnumerator: {
      title: 'エンティティの動的な列挙',
      description: `**式**を使って、列挙された複数エンティティの行を生成するカテゴリ項目を選択できます。例：\`unique(plot.land_use)\` は、プロットで実際に記録された土地利用についてのみ行を作成します。`,
    },
  },
}
